$(document).ready(function () {
    if ($(window).width() <= 600) {
        var $navLinks = $('.dropdownLink');
        var links = {};
        console.log($navLinks[0].parentElement.nextElementSibling);
        for (var i = 0; i < $navLinks.length; i++) {        
            var link = $($navLinks[i]).attr('href');
            var key = $navLinks[i].childNodes[0].data.trim();
            links[key] = link;
            
            $($navLinks[i]).attr('href', 'javascript:void(0)')

            var anchor = document.createElement('a'); 
            anchor.href = links[$navLinks[i].childNodes[0].data.trim()];
            anchor.text = $navLinks[i].childNodes[0].data.trim();
            console.log(anchor);

            $navLinks[i].parentElement.nextElementSibling.appendChild(anchor);
            $($navLinks[i]).click(function() {
                
                if($(this.parentElement.nextElementSibling).hasClass('mobile-display-on')) {
                    $(this.parentElement.nextElementSibling).removeClass('mobile-display-on');
                    $(this.parentElement.nextElementSibling).hide();
                }
                else {
                    $(this.parentElement.nextElementSibling).show();
                    $(this.parentElement.nextElementSibling).addClass('mobile-display-on');
                }
            })
            
        }
    }

})